import { useAppTranslation } from 'app/hooks';
import React from 'react';

interface LiveChatProps {
  className?: string;
}

const LiveChat: React.FunctionComponent<LiveChatProps> = ({ className = '' }) => {
  const t = useAppTranslation();

  return <div className={`chat-room__chatbox ${className}`}>{t('popup.comingSoon.title')}</div>;
};

export default LiveChat;
